export default __webpack_public_path__ + "static/media/LogoLearning.68a937b7.svg";